import { DOD_SERIES } from './constants';

export function buildDodSeries(data, { xAxisIndex = 1, yAxisIndex = 0, barChart = false }) {
  return {
    id: DOD_SERIES,
    name: 'DoD',
    data,
    type: barChart ? 'bar' : 'line',
    symbol: 'circle',
    showSymbol: false,
    xAxisIndex,
    yAxisIndex,
    itemStyle: {
      color: '#7B8FA1',
      opacity: barChart ? 0.5 : 1,
    },
    lineStyle: {
      width: 1.5,
      opacity: 0.7,
    },
    areaStyle: {
      opacity: 0,
    },
    markLine: {},
    triggerLineEvent: true,
  };
}
